import React from 'react';
import { Link } from 'react-router';
import './styles/Dashboard.scss';
import FA from 'utils/FA';
import { faSchool } from '@fortawesome/pro-solid-svg-icons/faSchool';
import PropTypes from 'prop-types';
import { sharedPortalStudents, sharedPortalDashboardSchools } from '../../ducks';
import { duckify } from '../../utils/duckify';
import PersonIcon from './PersonIcon';
import SsoAuthenticationLink from './SsoRedirect';

/**
 * The shared portal home page.
 */
const Dashboard = ({ schools }) => {
  let maxStudents = 0;
  schools.forEach((school) => {
    const kidCount = school.students.length;
    if (kidCount > maxStudents) {
      maxStudents = kidCount;
    }
  });
  return (
    <React.Fragment>
      <h1>Dashboard</h1>
      <p>Welcome to Finalsite Enrollment Explore.</p>
      <div className='sp-dashboard-students-applying'>
        <FA icon={faSchool} className='fa-2x' />
        <h2>Students Applying</h2>
        <Link className='btn btn-primary sp-dashboard-add-schools-button' to='/explore_schools'>Add Schools</Link>
      </div>
      <div className='sp-dashboard-schools'>
        {schools.map(school => (
          <div key={school.id} className='sp-dashboard-school-row'>
            <div className='sp-dashboard-logo-column'>
              {school.shared_portal_config.shared_portal_logo_url
                && <img src={school.shared_portal_config.shared_portal_logo_url} alt='School Logo' className='sp-dashboard-school-logo' />
              }
            </div>
            <div className='sp-dashboard-name-grade-column' >
              <div className='sp-dashboard-name-column'>
                <div className='sp-dashboard-school-name sp-dashboard-block'>
                  {school.shared_portal_config.school_name}
                </div>
                <div className='sp-dashboard-minor-text'>{school.shared_portal_config.address}</div>
              </div>
              <div className='sp-dashboard-grade-column'>
                <div className='sp-dashboard-minor-text sp-dashboard-block'>Grade Level</div>
                <div className='sp-dashboard-grade-value'>
                  {`${school.shared_portal_config.min_grade}-${school.shared_portal_config.max_grade}`}
                </div>
              </div>
            </div>
            <div className='sp-dashboard-checklist-column'>
              <SsoAuthenticationLink
                buttonText='View Checklist'
                schoolId={school.id}
                className='btn btn-primary sp-dashboard-checklist-button sp-dashboard-block'
              />
              <span className={`sp-dashboard-checklist-${school.is_complete ? 'complete' : 'incomplete'}`}>
                {school.checklist_message}
              </span>
            </div>
            <div className='sp-dashboard-icons-column'>
              {school.students.map(student => {
                const key = student ? student.id : 'empty';
                return (
                  <div key={key} className='sp-dashboard-student-icon'>
                    {student && <PersonIcon personName={student.student_name} notificationCount={student.remaining_items} />}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

    </React.Fragment>
  );
};
Dashboard.propTypes = {
  schools: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    checklist_message: PropTypes.string,
    is_complete: PropTypes.bool,
    shared_portal_config: PropTypes.shape({
      shared_portal_logo_url: PropTypes.string,
      address: PropTypes.string,
      min_grade: PropTypes.string,
      max_grade: PropTypes.string,
      school_name: PropTypes.string
    }),
    students: PropTypes.arrayOf(PropTypes.shape({
      student_name: PropTypes.string,
      remaining_items: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      id: PropTypes.string
    }))
  })).isRequired
};

const mapDucksToProps = () => ({
  schools: sharedPortalDashboardSchools
});

export default duckify(mapDucksToProps, undefined, undefined)(Dashboard);
